import { api } from './_apiInterface';
import { pointer } from 'src/app-config';
import { typeMeeting, typeMeetingsDoc } from '@monorepo/models';

class MeetingServices {
    private _base = pointer.meeting;
    //
    DeleteMidweek = async (meeting: typeMeeting) => {
        const data = await api.SendRequest(`${this._base}/midweek`, 'DELETE', { meeting });
        return data;
    }
    DeletePublic = async (meeting: typeMeeting) => {
        const data = await api.SendRequest(`${this._base}/public`, 'DELETE', { meeting });
        return data;
    }
    Get = async () => {
        const data = await api.SendRequest<{ meetingsDoc: typeMeetingsDoc; }>(this._base, 'GET');
        return data;
    }
    GetFree = async (congregation: number) => {
        const data = await api.SendRequest<{ meetingsDoc: typeMeetingsDoc; }>(`${this._base}?congregation=${congregation}`, 'GET');
        return data;
    }
    GetNewMidweek = async (weekNumber: number, year: number) => {
        const data = await api.SendRequest<{ midweekMeeting: typeMeeting; }>(`${this._base}/midweek?weekNumber=${weekNumber}&year=${year}`, 'GET');
        return data;
    }
    GetNewPublic = async (weekNumber: number, year: number) => {
        const data = await api.SendRequest<{ publicMeeting: typeMeeting; }>(`${this._base}/public?weekNumber=${weekNumber}&year=${year}`, 'GET');
        return data;
    }
    SaveAttendance = async (meeting: typeMeeting) => {
        const data = await api.SendRequest(`${this._base}/attendance`, 'POST', { meeting });
        return data;
    }
    SaveAvUshersAssignments = async (meetingsToSave: typeMeeting[], meetingsToDelete: typeMeeting[]) => {
        const data = await api.SendRequest(`${this._base}/avUsher`, 'POST', { meetingsToDelete, meetingsToSave });
        return data;
    }
    SaveCleaningAssignments = async (meetingsToSave: typeMeeting[], meetingsToDelete: typeMeeting[]) => {
        const data = await api.SendRequest(`${this._base}/cleaning`, 'POST', { meetingsToDelete, meetingsToSave });
        return data;
    }
    SaveMidweek = async (meeting: typeMeeting) => {
        const data = await api.SendRequest(`${this._base}/midweek`, 'POST', { meeting });
        return data;
    }
    SavePublic = async (meeting: typeMeeting) => {
        const data = await api.SendRequest(`${this._base}/public`, 'POST', { meeting });
        return data;
    }
}

export const meetingServices = new MeetingServices();
